import { render, staticRenderFns } from "./template-card.vue?vue&type=template&id=bbe18026&scoped=true&"
import script from "./template-card.vue?vue&type=script&lang=js&"
export * from "./template-card.vue?vue&type=script&lang=js&"
import style0 from "./template-card.vue?vue&type=style&index=0&id=bbe18026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe18026",
  null
  
)

export default component.exports